import {
  ADD_ALERT,
  ADD_ALERT_ERROR,
  ADD_ALERT_SUCCESS,
  ADD_MEDIA_FILE,
  ADD_MEDIA_FILE_ERROR,
  ADD_PATIENT_ALLERGY,
  ADD_PATIENT_ALLERGY_ERROR,
  CHECK_PHONE,
  CHECK_PHONE_ERROR,
  CLEAR_PAST_VISIT_INFO_DATA,
  CLEAR_PATIENT_LIST,
  COMPLETE_VISIT,
  COMPLETE_VISIT_ERROR,
  DELETE_ALERT,
  DELETE_ALERT_ERROR,
  DELETE_PATIENT_ALLERGY,
  DELETE_PATIENT_ALLERGY_ERROR,
  EDIT_ALERT,
  EDIT_ALERT_ERROR,
  EDIT_ALERT_SUCCESS,
  GET_ALERTS,
  GET_ALERTS_ERROR,
  GET_INTAKE_FORM,
  GET_INTAKE_FORM_ERROR,
  GET_INTAKE_FORM_SUCCESS,
  GET_MEDIA_FILES,
  GET_MEDIA_FILES_ERROR,
  GET_PAST_VISIT_INFO,
  GET_PAST_VISIT_INFO_ERROR,
  GET_PAST_VISIT_TREAT_LINK,
  GET_PAST_VISIT_TREAT_LINK_ERROR,
  GET_PATIENT_INTAKE_FORMS,
  GET_PATIENT_INTAKE_FORMS_ERROR,
  GET_PATIENT_PAST_VISITS,
  GET_PATIENT_PAST_VISITS_ERROR,
  GET_PATIENT_TREAT_LINK,
  GET_PATIENT_TREAT_LINK_ERROR,
  GET_PATIENT_TREAT_LINK_SUCCESS,
  GET_PATIENT_UPCOMING_VISITS,
  GET_PATIENT_UPCOMING_VISITS_ERROR,
  GET_PATIENTS_CHART,
  GET_PATIENTS_CHART_ERROR,
  GET_PATIENTS_LIST,
  GET_PATIENTS_LIST_ERROR,
  GET_PATIENTS_LIST_SUCCESS,
  GET_PRESCRIPTIONS,
  GET_PRESCRIPTIONS_ERROR,
  MARK_ALL_USER_ALERTS_AS_READ,
  MARK_ALL_USER_ALERTS_AS_READ_ERROR,
  SAVE_ACCOUNT_INFO,
  SAVE_ACCOUNT_INFO_ERROR,
  SAVE_GENERAL_INFO,
  SAVE_GENERAL_INFO_ERROR,
  SAVE_PATIENT_INSTRUCTIONS_ADDENDUM,
  SAVE_PATIENT_INSTRUCTIONS_ADDENDUM_ERROR,
  SAVE_VISIT_NOTES_ADDENDUM,
  SAVE_VISIT_NOTES_ADDENDUM_ERROR,
  SEARCH_FOR_ICD_CODES,
  SEARCH_FOR_ICD_CODES_ERROR,
  SEARCH_PHARMACIES,
  SEARCH_PHARMACIES_ERROR,
  SET_MEDIA_FILE_TAGS,
  SET_MEDIA_FILE_TAGS_ERROR,
  UNRESOLVE_VISIT,
  UNRESOLVE_VISIT_ERROR,
  UPDATE_ICD_CODES,
  UPDATE_ICD_CODES_ERROR,
} from '../charts/ChartsConstants'

export const chartsReducerBlackList = [
  GET_PATIENTS_LIST,
  GET_PATIENTS_LIST_SUCCESS,
  GET_PATIENTS_LIST_ERROR,
  CLEAR_PATIENT_LIST,
  GET_PATIENTS_CHART,
  GET_PATIENTS_CHART_ERROR,
  GET_ALERTS,
  GET_ALERTS_ERROR,
  ADD_PATIENT_ALLERGY,
  ADD_PATIENT_ALLERGY_ERROR,
  DELETE_ALERT,
  DELETE_ALERT_ERROR,
  DELETE_PATIENT_ALLERGY,
  DELETE_PATIENT_ALLERGY_ERROR,
  EDIT_ALERT,
  EDIT_ALERT_SUCCESS,
  EDIT_ALERT_ERROR,
  MARK_ALL_USER_ALERTS_AS_READ,
  MARK_ALL_USER_ALERTS_AS_READ_ERROR,
  SAVE_GENERAL_INFO,
  SAVE_GENERAL_INFO_ERROR,
  SAVE_ACCOUNT_INFO,
  SAVE_ACCOUNT_INFO_ERROR,
  CHECK_PHONE,
  CHECK_PHONE_ERROR,
  COMPLETE_VISIT,
  COMPLETE_VISIT_ERROR,
  UNRESOLVE_VISIT,
  UNRESOLVE_VISIT_ERROR,
  SEARCH_PHARMACIES,
  SEARCH_PHARMACIES_ERROR,
  SAVE_VISIT_NOTES_ADDENDUM,
  SAVE_VISIT_NOTES_ADDENDUM_ERROR,
  SAVE_PATIENT_INSTRUCTIONS_ADDENDUM,
  SAVE_PATIENT_INSTRUCTIONS_ADDENDUM_ERROR,
  GET_MEDIA_FILES,
  GET_MEDIA_FILES_ERROR,
  SET_MEDIA_FILE_TAGS,
  SET_MEDIA_FILE_TAGS_ERROR,
  ADD_MEDIA_FILE,
  ADD_MEDIA_FILE_ERROR,
  SEARCH_FOR_ICD_CODES,
  SEARCH_FOR_ICD_CODES_ERROR,
  UPDATE_ICD_CODES,
  UPDATE_ICD_CODES_ERROR,
  ADD_ALERT,
  ADD_ALERT_SUCCESS,
  ADD_ALERT_ERROR,
  GET_PRESCRIPTIONS,
  GET_PRESCRIPTIONS_ERROR,
  GET_PATIENT_TREAT_LINK,
  GET_PATIENT_TREAT_LINK_SUCCESS,
  GET_PATIENT_TREAT_LINK_ERROR,
  GET_PATIENT_PAST_VISITS,
  GET_PATIENT_PAST_VISITS_ERROR,
  GET_PATIENT_UPCOMING_VISITS,
  GET_PATIENT_UPCOMING_VISITS_ERROR,
  GET_INTAKE_FORM,
  GET_INTAKE_FORM_SUCCESS,
  GET_INTAKE_FORM_ERROR,
  GET_PATIENT_INTAKE_FORMS,
  GET_PATIENT_INTAKE_FORMS_ERROR,
  GET_PAST_VISIT_INFO,
  GET_PAST_VISIT_INFO_ERROR,
  GET_PAST_VISIT_TREAT_LINK,
  GET_PAST_VISIT_TREAT_LINK_ERROR,
  CLEAR_PAST_VISIT_INFO_DATA,
]
